// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyB8pzEvw-hVf8ZwjjUQCtzzo7IvjRQWlIk",
    authDomain: "constanza-project.firebaseapp.com",
    projectId: "constanza-project",
    storageBucket: "constanza-project.firebasestorage.app",
    messagingSenderId: "1098273327709",
    appId: "1:1098273327709:web:73025049f93e8042fe1bb4",
    measurementId: "G-GX9WWTT3Z8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export default app;
